import React, { Component, Fragment } from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import { categorySelectedTrigger } from './../../redux/actions';
import HeaderDropNav from  './../HeaderDropNav';
import { widths  } from './../../styles/theme.json';

class CategoryNavMobile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpen: false
    };
  }

  _dropClick(e) {
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  };

  _changeCategory(category) {
    this.props.categorySelected(category);
    this.setState(prevState => ({
      isOpen: !prevState.isOpen
    }));
  }

  componentDidMount() {
    this.props.categorySelected('everything');
  }

  componentWillUnmount() {
    this.props.categorySelected('everything');
  }

  render() {
    const navItems = this.props.Navigation.map((item, i) =>
      <li key={i} className={'category-menu-item-mobile'}>
        <NavLink to={`${this.props.Url}/${item.slug}`} className="mobile-category-link" onClick={() => this._changeCategory(item.slug)}>
          <span>{item.name}</span>
        </NavLink>
      </li>
    );
    return (
      <menu className={(this.state.isOpen) ? 'category-menu-mobile nav-drop' : 'category-menu-mobile'}>
      {(this.props.Url == '/fine-art')
        ? <div className={'nav-header'}>
            <div className={'mobile-category-link drop-down'}>Select Exhibitions</div>
          </div>
        : <Fragment>
            <HeaderDropNav currentPage={this.props.currentCategory} onClick={e => this._dropClick(e)} linkClass={'mobile-category-link drop-down'}/>
            <div className={'cat-nav-dropdown'}>
              <ul className={'desk-menu'}>
                {navItems}
                {(this.props.Url == '/publications') &&
                  <li className={'category-menu-item-mobile'}>
                    <NavLink to={'/publications/stockists'} className="mobile-category-link" onClick={() => this._changeCategory('Stocklists')}>
                      <span>{'Stockists'}</span>
                    </NavLink>
                  </li>
                }
              </ul>
              <div className={'cat-nav-bg-gradient'}/>
            </div>
          </Fragment>
        }
      </menu>
    );
  }
};

export default connect(
  state => ({
    currentCategory: state.current_sub_category,
    currentCategorySlug: state.current_category_slug
  }),
  dispatch => ({
    categorySelected: (category) => dispatch(categorySelectedTrigger(category))
  })
)(CategoryNavMobile);



// WEBPACK FOOTER //
// ./src/components/filter-pages/CategoryNavMobile.js